<template>
  <div ref="feedContainer" class="feedScrollerWrapper">
    <Notification :isSpecial="'wiim'" v-if="type === 'neutral' && latestWiim?._id" :type="'news'"
      :data-uuid="latestWiim._id" :feed-type="'news'" :notification="latestWiim"
      :hideEventsBySymbols="hideEventsBySymbols" @showBreaking="openSpecialFeed('showWiim', 'wiim')"
      :data-symbols="latestWiim.symbols.map(symbol => symbol.symbol).join(',')" :prices="prices"
      :isCollapsed="specialCollapsed" :key="`notification-wiim`" />
    <Notification :isSpecial="'latestBreaking'" v-if="type !== 'news' && type !== 'breaking' && latestBreaking?._id"
      :type="'news'" :data-uuid="latestBreaking._id" :feed-type="'news'" :notification="latestBreaking"
      :hideEventsBySymbols="hideEventsBySymbols" @showBreaking="openSpecialFeed('showBreaking', 'breaking')"
      :data-symbols="latestBreaking.symbols.map(symbol => symbol.symbol).join(',')" :prices="prices"
      :isCollapsed="specialCollapsed" :key="`notification-brk`" />


    <div ref="header" class="feedTitle" :class="{ isFavoriteFeed, isSymbolPage: type === 'symbolPage' }" v-if="['neutral', 'symbolPage'].includes(type) && !isPageLoading">
      <h3 v-if="type !== 'symbolPage'">
        {{
          type === 'breaking' ? dictionary.feeds.breakingNews : (isFavoriteFeed ? dictionary.feeds.stocksFavoriteFeed :
            dictionary.feeds.stocksFeed)
        }}
        <span id="feedTitleReturn" v-if="feedType === 'sector'">
          ({{ this.feedSymbols }})

          <span id="returnToPortfolio">
            <i class="ri-arrow-go-back-line" />
            {{ dictionary.feeds.backToPortfolio }}
          </span>
        </span>
      </h3>


      <div style="display: flex; align-items: center; gap: 5px" :style="setFilterStyle()">


        <div v-if="type === 'neutral'" class="soundsToggle" @click="toggleSounds()">
          <i class="ri-volume-mute-line" v-if="!soundsOn"/>
          <i class="ri-volume-up-line" v-else/>
        </div>


        <div v-if="type === 'neutral'" @click="toggleFavoriteFeed()"
          style="padding: 5px; cursor: pointer; margin-top: 2px">
          <i style="font-size: 20px; color: var(--lightYellow)" class="ri-star-line" v-if="!isFavoriteFeed" />
          <i style="font-size: 20px; color: var(--lightYellow)" class="ri-star-fill" v-else />
        </div>

        <div v-if="type === 'neutral' || type === 'symbolPage' || type === 'equity'" @click="showFilterSheet = true;"
          style="padding: 5px; cursor: pointer; margin-top: 2px;">
          <i style="font-size: 20px; color: var(--textColor)" class="ri-filter-line" />
        </div>

        <div v-if="type === 'neutral'" @click="toggleSpecialCollapse()"
          style="padding: 5px; cursor: pointer; margin-top: 2px">
          <i style="font-size: 20px; color: var(--textColor)" class="ri-arrow-up-s-line" v-if="!specialCollapsed" />
          <i style="font-size: 20px; color: var(--textColor)" class="ri-arrow-down-s-line" v-else />
        </div>

      </div>

      <div v-if="type === 'breaking'" @click="$emit('hideBreaking')"
        style="padding: 5px; cursor: pointer; margin-top: 2px">
        <i style="font-size: 20px" class="ri-close-line" />
      </div>
    </div>
    <BigLoader v-if="isPageLoading" />


    <empty-portfolio v-if="
      (!watchlist || (watchlist?.watchlist?.length === 0 && (type !== 'news' && type !== 'symbolPage')))
    " />

    <section v-if="!isPageLoading && (watchlist?.watchlist?.length > 0 || (type === 'news' || type === 'symbolPage'))"
      ref="feedSection">

      <Transition name="slide-fade">
        <div id="scrollToolbar" :style="setToolbarStylePosition()" v-if="!headerInView && feedVisible">
          <div class="action flex breaking" v-if="type !== 'news' && type !== 'breaking' && latestBreaking?._id"
            @click="openFeedWindow('breaking')">
            <i class="ri-fire-line" />
            <div>{{ specialCount.breaking }}</div>
          </div>

          <div class="action flex wiim" v-if="type === 'neutral' && latestWiim?._id" @click="openFeedWindow('wiim')">
            <i class="ri-arrow-left-right-line" />
            <div>{{ specialCount.wiim }}</div>
          </div>

          <div v-if="type === 'neutral'" class="action" @click="toggleFavoriteFeed()">
            <i style="color: var(--lightYellow)" class="ri-star-line" v-if="!isFavoriteFeed" />
            <i style="color: var(--lightYellow)" class="ri-star-fill" v-else />
          </div>

          <div v-if="type === 'neutral' || type === 'stocks' || type === 'equity'" class="action"
            @click="showFilterSheet = true;">
            <i style="color: var(--textColor)" class="ri-filter-line" />
          </div>

          <div class="action" @click="scrollToTop">
            <i class="ri-arrow-up-line" />
          </div>
        </div>
      </Transition>

      <empty-favorite-list v-if="!isPageLoading && isFavoriteFeed && groupNotificationsByDate.length === 0" />

      <div class="intersection" :key="feedKey" v-if="!isPageLoading">

        <div v-for="(day, dayI) in groupNotificationsByDate" class="dateBulk" :key="day.date">

          <h2 class="stickyDate" :class="{ withFilters: showFilters, withTabs: hasTabs }"><span class="text">{{
            day.format
              }}</span> <span class="stickyBg" :class="{ focusDay: !headerInView || inFloatingWindow }" /></h2>
          <div :ref="`notification-${nIdx}`" v-for="(notification, nIdx) in day.news"
            :key="`notification-w-${notification._id}`" class="notification">
            <Notification @showAggregation="showAggregation(notification.symbols, day.date, day.format)"
              :type="this.type === 'news' ? 'news' : 'equity'" :data-uuid="notification._id" :feed-type="this.type"
              :isSymbolPage="type === 'symbolPage'"
              :show-breaking-icon="type === 'symbol' || type === 'neutral'"
              :isDesktopFeed="isDesktopFeed()"
              :aggregate="aggregate || $route.path === '/feed' || $route.path === '/'" :notification="notification"
              :hideEventsBySymbols="hideEventsBySymbols"
              :data-symbols="notification.symbols.map(symbol => symbol.symbol).join(',')" :prices="prices"
              :key="`notification-${notification._id}`" />
          </div>
        </div>


        <div :class="type === 'symbol' ? 'intSymbol' : type === 'equity' ? 'int' : 'news'"></div>
      </div>

      <!-- <div class="loadMore" v-if="lastRequestState.hasNextPage" @click="loadNext">טעינת הודעות נוספות</div> -->
    </section>


    <section class="filtersSheet" v-if="showFilterSheet">
      <div class="backdrop" ref="backdrop" :style="setSheetWidth()">
        <div class="filtersList" :style="setFilterListStyle()">

          <div style="position: relative">
            <h2>{{ dictionary.feeds.filter }}</h2>
            <h2 class="closeFilter" @click="showFilterSheet = false"><i class="ri-close-line" /></h2>
          </div>
          <div class="tab" @click="filterNotifications('all')" :class="{ active: activeFilter.includes('all') }">
            <i class="ri-check-line" v-if="activeFilter.includes('all')" />
            {{ dictionary.feeds.filters.all }}
          </div>
          <div class="tab" @click="filterNotifications('pr')" :class="{ active: activeFilter.includes('pr') }">
            <i class="ri-check-line" v-if="activeFilter.includes('pr')" />
            {{ dictionary.feeds.filters.pr }}
          </div>
           <div class="tab" @click="filterNotifications('insiders')" :class="{ active: activeFilter.includes('insiders') }">
            <i class="ri-check-line" v-if="activeFilter.includes('insiders')" />
            {{ dictionary.feeds.filters.insiders }}
          </div>
          <div class="tab" @click="filterNotifications('earnings')"
            :class="{ active: activeFilter.includes('earnings') }">
            <i class="ri-check-line" v-if="activeFilter.includes('earnings')" />
            {{ dictionary.feeds.filters.earnings }}
          </div>

          <div class="tab" @click="filterNotifications('priceTargets')"
            :class="{ active: activeFilter.includes('priceTargets') }">
            <i class="ri-check-line" v-if="activeFilter.includes('priceTargets')" />
            {{ dictionary.feeds.filters.priceTargets }}
          </div>
          <div class="tab" @click="filterNotifications('financial_media')"
            :class="{ active: activeFilter.includes('financial_media') }">
            <i class="ri-check-line" v-if="activeFilter.includes('financial_media')" />
            {{ dictionary.feeds.filters.financialMedia }}
          </div>
          <div class="tab" @click="filterNotifications('bz')" :class="{ active: activeFilter.includes('bz') }">
            <i class="ri-check-line" v-if="activeFilter.includes('bz')" />
            {{ dictionary.feeds.filters.analysts }}
          </div>
        </div>
      </div>
    </section>

    <section class="aggregatorContainer" :style="setSheetWidth()" v-if="dailyFeed">
      <h3 class="dailyFeedTitle" @click="closeAggregation()">
        <i v-if="uiDirection === 'ltr'" class="ri-arrow-left-line" />
        <i v-else class="ri-arrow-right-line" />
        {{ dailyFeed.symbol }} @ {{ dailyFeed.formattedDate }}
      </h3>

      <big-loader :transparent-bg="true" v-if="dailyFeed.notifications.length === 0" />
      <div class="dailyFeed" v-else>
        <div :ref="`notification-d-${nIdx}`" v-for="(notification, nIdx) in dailyFeed.notifications"
          :key="`notification-d-id-${notification._id}`" class="notification">
          <Notification :type="this.type === 'news' ? 'news' : 'equity'" :data-uuid="notification._id"
            :feed-type="this.type" :show-breaking-icon="type === 'symbol' || type === 'neutral'"
            :notification="notification" :hideEventsBySymbols="hideEventsBySymbols"
            :data-symbols="notification.symbols.map(symbol => symbol.symbol).join(',')" :prices="prices"
            :key="`notification-${notification._id}`" />
        </div>
      </div>
    </section>

  </div>
</template>

<script>

import intersectionObserver from '../composables/intersectionObserver';

const { observedElement, elementClass, interOptions, interCallback, observer, callback } = intersectionObserver();
import { useRoute } from "vue-router";
import { DateTime } from 'luxon';
import NewsService from '@/services/news';
import Notification from "../components/feed/notification/Notification";
import { getCurrentInstance, ref } from 'vue'

import { useWatchlist } from "../stores/watchlist";
import BigLoader from "../components/ui/BigLoader";
import eventBus from "../services/events";
import EmptyPortfolio from "../components/ui/EmptyPortfolio";
import He from "../dictionary/he";
import EmptyFavoriteList from "../components/ui/EmptyFavoriteList";

import AggregateNotificationsByDateAndSymbols from "../composables/aggregateNotificationsByDateAndSymbols";

export default {
  name: 'Feed',
  emits: ['joinFilteredFeed', 'feedLoaded', 'toggleNotifications'],
  props: ['prices', 'symbols', 'type', 'symbol', 'showFilters', 'hasTabs', 'inFloatingWindow', 'hideEventsBySymbols', 'isBreakingOpen', 'isWiimOpen', 'feedVisible', 'aggregate'],
  data() {
    return {
      specialCollapsed: false,
      latestBreaking: null,
      latestWiim: null,
      specialCount: {
        breaking: 0,
        wiim: 0
      },
      soundsOn: false,
      wiimKey: 0,
      breakingKey: 0,
      dailyFeed: null,
      toolbarPosition: null,
      showFilterSheet: false,
      isFavoriteFeed: false,
      sheetWidth: 0,
      watchlist: useWatchlist(),
      activeFilter: ['all'],
      notificationsIds: new Set(),
      latestNotifications: [],
      feedKey: 0,
      isPageLoading: true,
      infiniteLoad: false,
      hasObserver: new Set(),
      observer: null,
      headerObserver: null,
      headerInView: true,
      refreshInterval: null,
      news: [],
      lastRequestState: {
        currentPage: 0
      }
    }
  },
  setup() {

    const app = getCurrentInstance();
    app.ctx.watchlist = useWatchlist();

    app.ctx.watchlist.$subscribe((mutation, state) => {

      app.ctx.loadFeed(true);
    });
  },
  beforeUnmount() {
    clearInterval(this.refreshInterval);
  },
  created() {
  },
  async mounted() {

    this.soundsOn = localStorage.getItem('soundsOn') === 'true' || localStorage.getItem('soundsOn') === null;

    this.refreshInterval = setInterval(() => {

      this.loadFeed(true).then().catch();
    }, 15 * 60 * 1000);

    let observerOptions = {
      rootMargin: '0px',
      threshold: 0
    }

    this.observer = new IntersectionObserver(this.observerCallback, observerOptions);


    const { access } = useRoute().query;
    this.setDesign(access);
    await this.loadFeed();


    eventBus.on('mainViewScrolledToBottom', this.loadNext);


    if (this.type === 'equity' || this.type === 'neutral') {
      eventBus.on('newEquityNotification', this.handleNewEquityNotification);
      eventBus.on('newNewsNotification', this.handleNewNewsNotification)
    } else if (this.type === 'symbol') {
      eventBus.on('newEquityNotification', this.handleNewSymbolNotification)
    } else if (this.type === 'news' || this.type === 'breaking' || this.type === 'wiim' || this.type === 'neutral') {
      eventBus.on('newNewsNotification', this.handleNewNewsNotification)
    }
  },
  computed: {
    groupNotificationsByDate() {


      if (this.aggregate || this.$route.name === 'Feed') {

        return AggregateNotificationsByDateAndSymbols(this.news, this.dateFormatLocale);
      } else {
        let dates = {};

        this.news.forEach(notifcation => {


          if (!isNaN(new Date(notifcation.datetime).getTime())) {
            const dateString = notifcation.date || DateTime.fromISO(notifcation.datetime).setLocale(this.dateFormatLocale).toFormat('yyyy-MM-dd');
            const dateFormat = notifcation.date ? DateTime.fromFormat(notifcation.date, 'yyyy-MM-dd').setLocale(this.dateFormatLocale).toFormat('DD') : DateTime.fromISO(notifcation.datetime).setLocale(this.dateFormatLocale).toFormat('DD');

            if (dateString === 'Invalid DateTime') return;
            if (!dates[dateString]) {
              dates[dateString] = {
                date: dateString,
                format: dateFormat,
                news: []
              };
            }

            if (dateString !== 'Invalid DateTime') {
              dates[dateString].news.push(notifcation);
            }
          }
        });

        const final = Object.values(dates);
        return final;
      }
    }
  },
  methods: {
    toggleSounds() {
      this.soundsOn = !this.soundsOn;
      eventBus.emit('soundsToggle', this.soundsOn);
    },
    setFilterStyle() {
      return {
        marginLeft: this.type === 'symbolPage' ? 'auto' : ''
      }
    },
    isDesktopFeed() {
      return window.innerWidth > 768 && this.type === 'neutral';
    },
    async showAggregation(symbol, date, formattedDate) {

      symbol = symbol.map(s => s.symbol).join(', ');
      this.dailyFeed = { symbol, date, formattedDate, notifications: [] }
      this.dailyFeed.notifications = (await NewsService.newsBySymbols({ symbols: symbol, query: { date } }))?.news ?? [];

      document.getElementById('view').style.overflow = 'hidden';
    },
    closeAggregation() {

      this.dailyFeed = null;
      document.getElementById('view').style.overflow = 'scroll';
    },
    openFeedWindow(feedName) {

      eventBus.emit('openFeedWindow', feedName);
    },
    scrollToTop() {

      const feed = document.getElementById('view');
      const view = document.getElementById('macroNewsFeed');

      if (feed && this.type === 'neutral' && window.innerWidth > 768) {
        feed.scrollTop = 0;
      } else if (view && this.type === 'neutral' && window.innerWidth <= 768) {
        view.scrollTop = 0;
      }
    },
    initHeaderObserver() {
      const target = this.$refs.header
      if (!target) return

      this.headerObserver = new IntersectionObserver(
        ([entry]) => {
          this.headerInView = entry.isIntersecting;
        },
        {
          rootMargin: '0px',
          threshold: 0.01
        }
      )
      this.headerObserver.observe(target)
    },
    setToolbarPosition() {

      if (!this.toolbarPosition) {
        const feed = this.$refs.feedContainer;
        const rect = feed.getBoundingClientRect();
        const top = rect.top + 'px';
        const width = rect.width;

        const right = rect.right + 'px';
        const left = rect.left + 'px';


        this.toolbarPosition = { top, right, left };
      }
    },
    setToolbarStylePosition() {

      if (!this.toolbarPosition) return { opacity: .1 }

      return this.uiDirection === 'ltr' ? {
        top: this.toolbarPosition.top,
        left: this.toolbarPosition.right
      } : { top: this.toolbarPosition.top, right: this.toolbarPosition.left }
    },
    toggleSpecialCollapse() {
      this.specialCollapsed = !this.specialCollapsed;
    },
    toggleFavoriteFeed() {

      this.isFavoriteFeed = !this.isFavoriteFeed;
      this.loadFeed(true);
    },
    setSheetWidth() {

      const width = this.$refs.feedContainer.clientWidth;
      if (this.type === 'symbolPage') return { width: 'auto',  left: 0, width: width + 'px', position: 'absolute' }
      return { width: this.sheetWidth }
    },
    setFilterListStyle () {

      if (this.type === 'symbolPage') return { marginTop: 0, height: 'auto' }
      return {  }
    },
    filterNotifications(filterName) {

      if (filterName === 'all') {

        this.activeFilter = ['all'];
      } else {

        const indexOf = this.activeFilter.indexOf(filterName);
        if (indexOf === -1) {
          this.activeFilter.push(filterName);
        } else {
          this.activeFilter.splice(indexOf, 1);
        }

        const indexOfAll = this.activeFilter.indexOf('all');
        if (indexOfAll > -1) this.activeFilter.splice(indexOfAll, 1);
      }

      if (this.activeFilter.length === 0) this.activeFilter = ['all'];
      this.loadFeed(true);
    },
    handleNewSymbolNotification(notification) {

      let isRelated = notification.symbols.find(symbol => symbol.symbol === this.symbol);
      if (isRelated) {

      }
    },
    handleNewNewsNotification(notification) {

      if (this.type === 'neutral') {

        if (notification.tags.includes('wiim')) {

          this.latestWiim = notification;
          if (!this.isWiimOpen) this.specialCount.wiim++;

          this.wiimKey++;
        } else if (notification.isBreaking || notification.isbreaking) {

          if (!this.isBreakingOpen) this.specialCount.breaking++;
          this.latestBreaking = notification;
          this.breakingKey++;
        }
      }


      if (
        (this.type === 'breaking' && notification.isBreaking) ||
        (this.type === 'wiim' && notification.notificationtype === 'wiim') ||
        (this.type === 'news')
      ) {
        if (!this.notificationsIds.has(notification._id)) {
          this.notificationsIds.add(notification._id);
          this.news.unshift(notification);

          this.$nextTick(() => {

            setTimeout(() => {
              const element = document.querySelector(`[data-uuid="${notification._id}"]`);

              if (element) {
                element.classList.add('newMessage')

                setTimeout(() => {

                  element.classList.remove('newMessage');
                }, 10100);
              }
            }, 400);
          })
        }
      }
    },
    handleNewEquityNotification(notification) {


      if (this.watchlist.watchlist && this.watchlist.watchlist.length > 0 && !notification.symbols.some(symbol => this.watchlist.watchlist.includes(symbol.symbol || symbol))) return;

      if (!this.activeFilter.includes('all')) {

        const shouldBlockNotification = this.shouldBlockNotificationByFilter(notification);
        if (shouldBlockNotification) return;
      }

      // if (this.aggregate) {
      //
      //   const notificationDateFormat = DateTime.fromISO(notification.datetime).toFormat('yyyy-MM-dd');
      //   const notificationSymbol = notification.symbols[0].symbol;
      //
      //   const findIndex = this.news.findIndex(existingHeadline => {
      //     const existingSymbol = existingHeadline.symbols[0].symbol;
      //     const existingDateFormat = DateTime.fromISO(existingHeadline.datetime).toFormat('yyyy-MM-dd');
      //     return (existingSymbol === notificationSymbol && existingDateFormat === notificationDateFormat)
      //   });
      //
      //   if (findIndex > -1) this.news.splice(findIndex, 1);
      // }
      this.news.unshift(notification);

      this.$nextTick(() => {
        const element = document.querySelector(`[data-uuid="${notification._id}"]`);

        if (element) {
          setTimeout(() => {
            element.classList.add('newMessage')

            setTimeout(() => {

              element.classList.remove('newMessage');
            }, 10100);
          }, 400);

          this.observer.observe(element);
          this.hasObserver.add(notification._id);
        }
      })
    },
    openSpecialFeed(type, countType) {
      this.specialCount[countType] = 0

    },
    shouldBlockNotificationByFilter(notification) {

      let activeFilters = {};

      if (this.activeFilter.includes('SEC')) {
        activeFilters.sec = notification.sourceName !== 'SEC' && !notification.tags.includes('sec') && notification.sourceType !== 'SEC';
      }

      if (this.activeFilter.includes('pr')) {
        activeFilters.pr = notification.sourceType !== 'pr';
      }

      if (this.activeFilter.includes('financial_media')) {
        activeFilters.financial_media = notification.sourceType !== 'financial_media';
      }

      if (this.activeFilter.includes('bz')) {
        activeFilters.bz = notification.sourceType !== 'bz' && notification.sourceType !== 'bz_wire';
      }


      return Object.values(activeFilters).every(value => value === true);
    },

    async loadNext() {
      if (this.lastRequestState.hasNextPage && !this.infiniteLoad) {

        this.infiniteLoad = true;
        this.lastRequestState.currentPage += 1;
        await this.loadFeed();
      }
    },
    async loadFeed(shouldReset = false) {

      if (this.watchlist?.watchlist?.length === 0 && (this.type !== 'news' && this.type !== 'wiim' && this.type !== 'symbolPage')) {
        this.isPageLoading = false;
        return;
      }

      if (shouldReset) {
        this.news = [];

        this.lastRequestState = {
          currentPage: 0
        }
      }

      if (this.lastRequestState.currentPage === 0) {
        this.isPageLoading = true;
      }

      let data = null;

      if ((this.type !== 'news' && this.type !== 'breaking' && this.type !== 'wiim' && this.$route.name !== 'Macro' && this.type !== 'filteredFeed') || this.type === 'neutral') {

        if ((this.symbols && this.symbols.length > 0)) {
          // if ((this.symbols && this.symbols.length > 0) || (this.$route.params.symbol)) {

          let query = { page: this.lastRequestState.currentPage };
          if (this.activeFilter !== 'all') query.sourceType = this.activeFilter.join(',');

          if (this.type !== 'sector') {
            data = await NewsService.newsBySymbols({
              symbols: this.symbols,
              query
            });
          } else {
            // data = await NewsService.getSectorFeed(this.$route.params.symbol || this.symbols,{
            //   query
            // });
          }

        } else {

          let query = { page: this.lastRequestState.currentPage };
          if (this.activeFilter !== 'all') query.sourceType = this.activeFilter.join(',');
          if (this.isFavoriteFeed) query.favoriteOnly = this.isFavoriteFeed;
          data = await NewsService.getFeed(query);

          this.latestBreaking = data.latestBreaking || null;
          this.latestWiim = data.latestWiim || null;
        }

      } else if (this.type === 'filteredFeed') {

        data = await NewsService.getFeedByFilterId(this.$route.params.feedId);
        this.$emit('joinFilteredFeed', this.$route.params.feedId);

      } else if (this.type === 'wiim') {

        data = await NewsService.macroNews({ query: { page: this.lastRequestState.currentPage, specialType: 'wiim' } })
      } else if (this.type === 'breaking') {

        data = await NewsService.macroNews({ query: { page: this.lastRequestState.currentPage, specialType: 'breaking' } })
      } else {

        data = await NewsService.macroNews({ query: { page: this.lastRequestState.currentPage } })
      }

      // const data = await NewsService.getFeed({page: this.lastRequestState.currentPage})
      this.news = this.news.concat(data.news);

      this.lastRequestState = {
        currentPage: this.lastRequestState.currentPage,
        hasNextPage: this.lastRequestState.currentPage < data.pages,
        pages: data.pages,
      }


      this.isPageLoading = false;
      this.infiniteLoad = false;

      let target = '.notification';
      document.querySelectorAll(target).forEach((i) => {

        let notificationId = i.dataset.uuid;
        if (i && !this.hasObserver.has(notificationId)) {
          this.notificationsIds.add(notificationId)
          this.hasObserver.add(notificationId);
          this.observer.observe(i);
        }
      });


      this.feedLoaded();
      this.$nextTick(() => {

        const feedWidth = this.$refs.feedContainer?.clientWidth;

        if (feedWidth) {
          this.sheetWidth = `${feedWidth}px`;
          this.setToolbarPosition();
          this.initHeaderObserver();
        }
      });

      // this.feedKey++;
    },
    observerCallback(entries, observer) {
      let quotesForSymbols = new Set();

      entries.forEach(entry => {
        if (entry.isIntersecting) {

          let symbols = entry.target.dataset.symbols;
          if (symbols) {

            symbols.split(/\,/g).forEach(symbol => quotesForSymbols.add(symbol));
          }
        }
      });

      this.$emit('feedLoaded', Array.from(quotesForSymbols));
    },
    feedLoaded() {

      const symbols = this.news.reduce((final, current) => {

        current.symbols.forEach(symbol => symbol.symbol ? final.add(symbol.symbol) : null);
        return final;
      }, new Set());

      this.$emit('feedLoaded', Array.from(symbols));
    },
    setDesign(accessCode) {
      if (accessCode === '1') {
        document.documentElement.style.setProperty('--headlineColor', '#00f');
        document.documentElement.style.setProperty('--dir', 'rtl');
      }
    }
  },
  components: { EmptyFavoriteList, He, EmptyPortfolio, BigLoader, Notification }
}
</script>

<style lang="scss">
.stickyDate {
  position: sticky;
  background: var(--bgColor);
  padding: 5px .5rem;
  border-bottom: 2px solid var(--notficationBorderColor);
  box-shadow: 0 5px 5px 0 rgba(15, 15, 15, .05);
  margin: 0;
  font-size: 16px;
  top: 0 !important;
  z-index: 3;

  .text {
    z-index: 2;
    color: var(--textColor);
  }

  .stickyBg {
    transition: all .2s ease-in;

    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;

    &.focusDay {
      background: var(--highlightColorOpacity);
    }
  }

}

.newMessage {
  animation-name: newMessage;
  animation-duration: 10s;
}

.loadMore {
  background: var(--highlightColorOpacity);
  color: var(--highlightColor);
  text-align: center;
  padding: 10px;
  font-weight: 600;
  border-radius: 8px;
  margin: 1rem;

  @media (min-width: 660px) {
    display: none;
  }
}

@keyframes newMessage {
  0% {
    background-color: inherit;
  }

  30% {
    background-color: var(--newMessageBg);
  }

  100% {
    background-color: inherit;
  }
}


.tabs {
  border-top: 1px solid var(--notficationBorderColor);
  z-index: 10;

  &.hasTabs {
    top: 44px;
  }
}

.withFilters {
  top: 5px;

  &.withTabs {
    top: 78px;
  }
}

.backdrop {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgb(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;

  .filtersList {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    background: var(--bgColor);
    overflow: hidden;
    width: 100%;
    height: 400px;
    margin-top: auto;

    .closeFilter {
      cursor: pointer;
      background: rgba(255, 255, 255, .2);
      border-radius: 50%;
      width: 5px;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 5px;
      top: 5px;
      transform: translateY(-50%);
    }

    h2 {
      padding: 0 1rem;
      font-size: 22px;
      margin: 10px 0;
    }

    .tab {
      padding: 8px 10px;
      border-bottom: 1px solid var(--notficationBorderColor);
      cursor: pointer;
    }

    .tab.active {
      background: var(--highlightColorOpacity);
      color: var(--navBarLinkActiveColor);
    }
  }
}



#scrollToolbar {
  z-index: 9;
  position: fixed;
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  padding: 0 1rem;
  gap: 15px;
  backdrop-filter: blur(20px);
  transform: translateX(-100%);
  overflow: hidden;

  .action {
    cursor: pointer;

    &.flex {
      flex-direction: row;
      display: flex;
      align-items: center;
    }

    &.breaking {
      background: var(--red);
      border-radius: 8px;
    }

    &.wiim {
      border-radius: 8px;
      background: var(--purple);
    }

    &.fave {
      background: var(--lightYellow);
    }

    font-size: 18px;
    color: var(--textColor);
    padding: 0px 5px;
  }
}

.slide-fade-enter-active {
  transition: all 0.25s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
}

.dateBulk {
  box-sizing: border-box;
  border-bottom: 5px solid var(--notficationBorderColor);
}

.feedScrollerWrapper {
  position: relative;
}

.aggregatorContainer {
  position: fixed;
  top: 35px;
  left: 0;
  width: 100%;
  height: calc(100% - 35px);
  background: var(--bgColor);
  z-index: 99;
  overflow-y: auto;
}

.dailyFeedTitle {
  position: sticky;
  top: 0;
  padding: 3px .5rem .5rem;
  margin: 0;
  background: var(--bgColor);
  border-bottom: 2px solid var(--notficationBorderColor);
  z-index: 4;
  cursor: pointer;
}

[data-theme="light"] {

  .breaking,
  .wiim {
    color: var(--bgColor) !important;
  }
}
</style>
